/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geototalopens2Inputs */

const en_geototalopens2 = /** @type {(inputs: Geototalopens2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens`)
};

const de_geototalopens2 = /** @type {(inputs: Geototalopens2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnungen`)
};

/**
* | output |
* | --- |
* | "Opens" |
*
* @param {Geototalopens2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geototalopens2 = /** @type {((inputs?: Geototalopens2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geototalopens2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geototalopens2(inputs)
	return de_geototalopens2(inputs)
});
export { geototalopens2 as "geoTotalOpens" }